module.exports = __webpack_public_path__ + "static/media/Icon_Tow_Truck.ea517002.svg";